import { TwoFactorStepType } from 'data/types'

import * as AT from './actionTypes'

export type SubmitTwoFactorActionType = {
  payload: { readonly step: TwoFactorStepType }
  type: typeof AT.SUBMIT
}

export type TwoFactorActionType = { type: typeof AT.GET_STATUS } | SubmitTwoFactorActionType

const getStatus = (): TwoFactorActionType => ({
  type: AT.GET_STATUS
})

const submit = (step: TwoFactorStepType): TwoFactorActionType => ({
  payload: { step },
  type: AT.SUBMIT
})

export default { getStatus, submit }
